module.exports = __webpack_public_path__ + "img/bg_intro_2_8_m.a033cae6.png";